import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { LOGO } from "@/lib/constants";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("wm_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FBF7F0] flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src={LOGO}
            alt="Gezond met Vera"
            className="h-24 w-auto mx-auto rounded-2xl mb-4"
          />
          <h1 className="text-3xl text-[#2C3E35]">Welzijnsmonitor</h1>
          <p className="text-[#5B6B61] text-sm mt-1">Beheerdersdashboard</p>
        </div>

        <form
          onSubmit={login}
          className="bg-white rounded-3xl p-8 shadow-[0_8px_30px_rgba(44,62,53,0.06)] border border-[#E5E7E1]"
        >
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-[#2C3E35] mb-1.5">E-mail</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email-input"
                className="wm-input"
                placeholder="vera@gezondmetvera.be"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-[#2C3E35] mb-1.5">Wachtwoord</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password-input"
                className="wm-input"
                placeholder="••••••••"
                required
              />
            </div>
          </div>

          {error && (
            <p data-testid="admin-login-error" className="text-sm text-[#C86B5E] mt-4">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-button"
            className="mt-6 w-full bg-[#6B8E74] hover:bg-[#56745E] disabled:opacity-50 text-white rounded-full px-8 py-3.5 text-base font-medium transition-all hover:-translate-y-0.5 flex items-center justify-center gap-2"
          >
            {loading ? <Loader2 className="animate-spin" size={18} /> : <Lock size={18} />}
            Inloggen
          </button>
        </form>

        <p className="text-center text-sm text-[#8FA38C] mt-6">
          <a href="/" className="hover:text-[#5B6B61]">← Terug naar de welzijnscheck</a>
        </p>
      </div>
    </div>
  );
}
